<template>
    <div class="chart">
        <div class="chart-title">{{ option.title||$t('HT.advancedService.invocationCount') }}</div>
        <div class="chart-content">
            <div class="chart-search">
                <div class="chart-search__item"><el-radio-group v-model="form.dateType" @change="changeType" size="small">
                        <el-radio-button label="1">{{ $t('Common.date.today') }}</el-radio-button>
                        <el-radio-button label="2">{{ $t('Common.date.day7') }}</el-radio-button>
                        <el-radio-button label="3">{{ $t('Common.date.day30') }}</el-radio-button>
                        <el-radio-button label="4">{{ $t('Common.date.year') }}</el-radio-button>
                    </el-radio-group></div>
                <div class="chart-search__item">
                    <ux-date v-model="form.date" daterange @change="changeDaterage"></ux-date>
                </div>
            </div>
            <div class="chart-data">
                <div class="echart-wrap" :id="el"></div>
            </div>
        </div>
    </div>
</template>

<script>
import echarts from '@/plugins/echarts';
export default {
  name: 'lineChart',
  props: {
    el: { type: String, default: 'echart-wrap' },
    option: { type: Object, default: () => { } }
  },
  data() {
    return {
      form: {
        dateType: '1',
        date: []
      },
      $echart: null,
      defaultOption: {
        title: {
          text: ''
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: [this.option.title]
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        toolbox: {
          feature: {
            dataView: {
              show: true,
              lang: ['数据视图', '关闭', '刷新']
            },
            magicType: { show: true, type: ['line', 'bar'] },
            restore: {
              show: false
            },
            myTool1: {
              show: true,
              title: this.$t('HT.reset'),
              icon: 'path://M292.072727 384.465455a25.6 25.6 0 1 1-44.311272-25.646546 303.476364 303.476364 0 0 1 566.272 151.738182 25.6 25.6 0 0 1-51.2 0A252.276364 252.276364 0 0 0 292.072727 384.465455zM207.127273 510.603636a25.6 25.6 0 1 1 51.2 0 252.276364 252.276364 0 0 0 252.276363 252.276364 251.066182 251.066182 0 0 0 190.603637-86.993455l28.718545-37.143272a25.6 25.6 0 1 1 40.494546 31.325091l-29.556364 38.167272A303.476364 303.476364 0 0 1 207.127273 510.603636z',
              onclick: () => {
                this.reset();
              }
            },
            saveAsImage: {},
          }
        },
        xAxis: {
          type: 'category',
          data: []
        },
        yAxis: {
          type: 'value',
          name: this.$t('HT.label.totalTimes'),
          axisLine: {
            show: true
          }
        },
        series: [
          {
            data: [],
            name: this.option.title,
            type: 'line',
            stack: 'Total',
          },
        ],
        color: '#3387FF'
      }
    };
  },
  watch: {
    option: {
      handler(newVal) {
        this.$echart.clear();
        this.init(newVal);
      },
      deep: true
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.init(this.option);
    });
    window.addEventListener('resize', this.handleResize);
    this.$once('hook:beforeDestroy', this.handleResize);
  },
  methods: {
    // 初始化图表
    init(data) {
      if (!this.$echart) {
        this.$echart = echarts.init(document.getElementById(this.el));
      }
      if (data) {
        this.defaultOption.xAxis.data = data.xAxisData;
        this.defaultOption.series[0].data = data.seriesData;
        this.defaultOption.series[0].name = data.title;
      }
      this.$echart.setOption(this.defaultOption);
    },
    handleResize() {
      this.$echart.resize();
    },
    changeType() {
      this.form.date = [];
      this.handleEmit();

    },
    changeDaterage(date) {
      if (date?.length) {
        this.form.dateType = '5';
        const [startTime, endTime] = date || [];
        this.form.startTime =startTime+' 00:00:00';
        this.form.endTime =endTime+' 23:59:59';
      }
      this.handleEmit();
    },
    handleEmit(){
      const { product_id, product_name } = this.option;
      const index = this.$attrs.index;
      this.$emit('change', {...this.form,product_id, product_name, index});
    },
    reset() {
      this.form.dateType = '1';
      this.form.date = [];
      this.form.startTime = '';
      this.form.endTime = '';
      this.handleEmit();
    }
  }
};
</script>

<style lang="scss" scoped>
.chart {
    margin: 20px;
    padding: 20px;
    background: #fff;
    margin-bottom: 10px;
    border-radius: 10px;

    &-title {
        color: #1D2944;
        font-weight: 600;
        font-size: 16px;
        line-height: 60px;
    }

    &-content {}

    &-search {
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        &__item {
            margin-right: 10px;
        }
    }

    &-data {}
}

.echart-wrap {
    width: 100%;
    height: 400px;
}
</style>
